/**
 * Route guard for a permission.
 *
 * Zero-Clutter / Defense-in-Depth: When an unauthorized URL is directly accessed
 * or tampered with, the client redirects the user away immediately without
 * exposing forbidden screens or unauthorized banners.
 */
import { Navigate } from 'react-router-dom';
import { useTenant } from '../context/TenantContext.jsx';
import { useOrgBase } from './orgNavigation.jsx';

export function RequirePermission({ permissions, what, children }) {
  const { can, loading } = useTenant();
  const base = useOrgBase();

  // Wait for the permission set to load rather than briefly showing a denial.
  if (loading) return null;

  if (!can(...permissions)) {
    return <Navigate to={base || '/'} replace />;
  }

  return children;
}
